<template>
  <div class="chapter-stats">
    <div
      class="chapter-square-main shrink-on-active"
      :class="{ chaptersquareactive: page == 'savedwords' }"
      @click="changePage('savedwords')"
    >
      <p class="statNum" :class="{ notSelected: page !== 'savedwords' }">
        {{ words }}
      </p>
      <p class="statText">
        {{ $t("chapter.chapter-stats.words") }}
      </p>
    </div>
    <div
      class="chapter-square-main shrink-on-active"
      :class="{ chaptersquareactive: page == 'grammar' }"
      @click="changePage('grammar')"
    >
      <p class="statNum" :class="{ notSelected: page !== 'grammar' }">
        {{ grammer }}
      </p>
      <p class="statText">
        {{ $t("chapter.chapter-stats.grammar") }}
      </p>
    </div>
    <div
      class="chapter-square-main shrink-on-active"
      :class="{ chaptersquareactive: page == 'sentence' }"
      @click="changePage('sentence')"
    >
      <p class="statNum" :class="{ notSelected: page !== 'sentence' }">
        {{ sentance }}
      </p>
      <p class="statText">
        {{ $t("chapter.chapter-stats.sentences") }}
      </p>
    </div>
  </div>
</template>

<script>
import "./chapter-stats.scss";
export default {
  name: "chapter-stats",
  props: ["words", "grammer", "sentance", "ranking", "page", "changePage"],
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.chaptersquareactive {
  color: var(--header-primary);
  background: var(--bubble-bg-selected);
  border: solid 2px var(--header-secondary);
  box-shadow: none;
}
.statNum {
  margin-bottom: 0px !important;
}
.notSelected {
  color: var(--color-primary);
}
</style>



// WEBPACK FOOTER //
// chapter-stats.vue?3ee8d3e6